// @flow
import React, { useState, useEffect } from 'react'
import type { PreviewData } from '../AdEdit/NamedPreview'
import ProviderPreviews from '../AdEdit/ProviderPreviews'
import type { Node } from 'react'
import getJson from '../../services/getJson'
import type { Public } from '../types'
import _ from 'lodash'
import AdvertisementPreviewSwitcher from '../AdEdit/AdvertisementPreviewSwitcher'

const audiencesPath = '/api/v1/audiences'

export type Props = {|
  header?: Node,
  previewNames: Array<string>,
  previewData: Array<PreviewData>,
  audienceIds: Array<number>,
  dispatch: Function // eslint-disable-line react/no-unused-prop-types
|}

export default function Previews(props: Props) {
  const [currentAjax, setCurrentAjax] = useState(null)
  const [dataPatch, setDataPatch] = useState<$Shape<PreviewData>>({})
  const [statePreviewIndex, setStatePreviewIndex] = useState(0)

  useEffect(() => {
    const ids = props.audienceIds
    if (ids.length === 0) {
      setDataPatch({})
    } else {
      if (currentAjax) {
        currentAjax.abort()
      }
      const ajax = getJson(audiencesPath, { ids: ids.join(',') })
      setCurrentAjax(ajax)
      ajax
        .then((response) => {
          const audiences = response.data
          let patch = {}
          _.each(audiences, (audience: { vk_public: Public, fb_public: Public }) => {
            if (audience.fb_public) patch = { ...patch, fbPublic: audience.fb_public }
            if (audience.vk_public) patch = { ...patch, vkPublic: audience.vk_public }
          })
          setDataPatch(patch)
        })
        .always(() => setCurrentAjax(null))
    }
  }, [props.audienceIds])

  return props.previewNames.length === 0 ? null : (
    <div>
      {props.header}
      {props.previewData.length > 1 && (
        <AdvertisementPreviewSwitcher
          previews={props.previewData}
          selectedIndex={previewIndex(props, statePreviewIndex)}
          onChange={(index: number) => {
            setStatePreviewIndex(index)
          }}
        />
      )}
      <ProviderPreviews
        names={props.previewNames}
        data={{ ...props.previewData[previewIndex(props, statePreviewIndex)], ...dataPatch }}
      />
    </div>
  )
}

function previewIndex(props: Props, statePreviewIndex: number): number {
  const { previewData } = props

  if (statePreviewIndex < previewData.length) return statePreviewIndex

  return 0
}
